import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Checkbox');

const propTypes = {
    id: PropTypes.string,
    value: PropTypes.any,
    checked: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.string,
    render: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    isCheckoutV3: PropTypes.bool
};

const defaultValues = {
    checked: false
};

function Checkbox(props) {
    const { id, className, children, render, checked, hasError, value, isCheckoutV3, ...rest } = props; // eslint-disable-line no-unused-vars

    return (
        <div className={bem(null, { isCheckoutV3 }, className)}>
            <div className={bem('input', [hasError && 'error', isCheckoutV3 ? 'isCheckoutV3' : ''])}>
                <input type="checkbox" id={id} checked={checked || value === true} {...rest} />
            </div>
            {children ? (
                <label htmlFor={id} className={bem('label')}>
                    {children}
                </label>
            ) : null}
            {typeof render === 'function' ? render(props) : render}
        </div>
    );
}

Checkbox.propTypes = propTypes;
Checkbox.defaultValues = defaultValues;

export default Checkbox;
